import api from "./core";

const basePath = "api/kiosk/EpisodeOfCare";

export default {
  async get(id) {
    return api.get(`${basePath}/${id}`);
  }
};
